import { Component, Input } from '@angular/core';
import { Article } from '@ca/core/models';
import { WindowRef } from '@ca/core/services';
import { MAILTO_LINK_PREFIX } from '../../constants/constants';

@Component({
    selector: 'ca-article',
    templateUrl: './article.component.html',
    styleUrls: ['./article.component.scss'],
})
export class ArticleComponent {
    @Input() article: Article;

    constructor(private windowRef: WindowRef) {}

    triggerAction(actionUrl: string): void {
        if (actionUrl.toLowerCase().startsWith(MAILTO_LINK_PREFIX)) {
            this.windowRef.nativeWindow.open(actionUrl);
        } else {
            this.windowRef.nativeWindow.open(actionUrl, '_blank');
        }
    }
}
